import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { dialog: String };

  open(event) {
    const url = event.params.url;
    if (!url) {
      return;
    }

    const indexUrl = window.location.href;

    window.history.pushState({ submissionModal: true }, '', url);

    const popstateHandler = () => {
      document.getElementById(this.dialogValue)?.close();
    };
    window.addEventListener('popstate', popstateHandler);

    const closeHandler = (closeEvent) => {
      if (closeEvent.target.id !== this.dialogValue) {
        return;
      }

      document.removeEventListener('ui--twin-turbo-modal:close', closeHandler);
      window.removeEventListener('popstate', popstateHandler);
      window.history.replaceState(null, '', indexUrl);
    };
    document.addEventListener('ui--twin-turbo-modal:close', closeHandler);
  }
}
